document.addEventListener("DOMContentLoaded", function () {
    // Function to handle the radio input change event
    function handleRadioChange() {
        const statisticsByLetter = document.querySelector(".countries-statistics--letter")
        const statisticsByGoal = document.querySelector(".countries-statistics--goals")

        if(statisticsByLetter != null && statisticsByGoal != null){
            if (document.getElementById("sortLetter").checked) {
                // Show .countries-statistics--letter and hide .countries-statistics--goals
                statisticsByLetter.classList.remove("d-none")
                statisticsByGoal.classList.add("d-none")
            } else if (document.getElementById("sortGoals").checked) {
                // Show .countries-statistics--goals and hide .countries-statistics--letter
                statisticsByGoal.classList.remove("d-none")
                statisticsByLetter.classList.add("d-none")
            }
        }
    }

    // Add change event listeners to the radio inputs
    const sortLetterInput = document.getElementById("sortLetter")
    if(sortLetterInput != null){
        sortLetterInput.addEventListener("change", handleRadioChange)
    }

    const sortGoalsInput = document.getElementById("sortGoals")
    if(sortGoalsInput != null){
        sortGoalsInput.addEventListener("change", handleRadioChange)
    }

    // Initialize the visibility based on the initially checked radio input
    handleRadioChange()
})